/*

? First, let's import the interface that will describe the shape of our chat object.

*/

import StateInterface from "../state-interface";

/*

& Now let's describe an initial state for the chat object. This is the state that will be used when the app first fires up. Think of it like a placeholder.

*/

export const chat: StateInterface["chat"] = {
	_id: "6310a47582b774b3ac71c5ad",
	chat_type: "direct",
	chat_title: "",
	chat_description: "",
	chat_dp: {
		file_id: "",
		original_file_server_path: "",
	},
	participants: [],
	admins: [],
	last_message: {
		body: "",
		sender_is_business_profile: false,
		sender_user_id: "6310a47582b774b3ac71c5ad",
		sender_business_profile_id: "6310a47582b774b3ac71c5ad",
		sent_at: "",
	},
	notification_settings: [],
	created_by: {
		is_business_profile: false,
		user_id: "6310a47582b774b3ac71c5ad",
		business_profile_id: "6310a47582b774b3ac71c5ad",
	},
	unread_messages_count: [],
	created_at: "",
	is_vanish_mode: false,
	vanish_at: "",
	trigger_vanish_at: "",
	updated_at: "",
	deleted_for: [],
	is_broadcast: false,
	broadcast_id: "",
};
